<template>
  <div class="page protocol">
    <navigation>个人借款合同</navigation>
        
    <section class="content">
      <p class="text tab-2" style="float: right">合同编号：<strong>●1</strong></p>
      <br>
      <br>
      <p class="text tab-2" style="margin-top: 40px">
      <strong>特别提醒：在借款人（即“乙方”，以下称“乙方”或“您”）确认签订本合同之前，乙方应事先了解本合同条款的全部内容，并保证向【青海银行股份有限公司】及其下属分支机构（以下简称“贷款人”，即“甲方”，以下称“甲方”）申请个人消费性借款（以下简称“本借款”或“借款”）为乙方本人的真实意思表示。乙方在甲方或其合作方的网站或其他与本借款相关的软件客户端（以下特指“业务平台”）点击接受本合同，即表示乙方已阅读本合同所有条款，并对本合同条款的含义及相应的法律后果已全部知晓并充分理解，同意接受本合同约束。深圳市中资联融资担保有限公司为本次借款担保服务，具体内容由乙方与深圳市中资联融资担保有限公司（以下简称“中资联担保”）另行签订的《服务合同》（以实际签署的名称为准）进行说明。</strong></p>
      <p class="text tab-2">
        <strong>(二）为充分维护乙方的合法权益，甲方特提醒乙方特别关注本合同条款中的黑体及/或加下划线部分。本合同若干条款（包括但不限于第五条、第七条、第八条、第十一条至第十九条等）含有限制或免除甲方责任的内容，请乙方务必仔细阅读。</strong>
      </p>
      <div>
        <p class="text tab-2"><strong>第一条 借款基本信息</strong></p>
      </div>
      <p class="text tab-2"><strong>为保护乙方信息，本合同在业务平台展示时部分隐藏了乙方的身份信息和收款账户信息，乙方了解并同意本合同项下乙方的身份信息以乙方在业务平台留存的信息为准。</strong>
      </p>
      <p class="text tab-2"><strong>贷款人：【青海银行股份有限公司】</strong></p>
      <p class="text tab-2"><strong>借款人：●2</strong></p>
      <p class="text tab-2"><strong>证件类型：身份证</strong></p>
      <p class="text tab-2"><strong>证件号码：●3</strong></p>
      <p class="text tab-2"><strong>送达地址：●4</strong></p>
      <p class="text tab-2"><strong>手机号码：●5</strong></p>
      <p class="text tab-2"><strong>电子邮箱：●6</strong></p>
      <p class="text tab-2"><strong>借款用途：日常消费</strong></p>
      <p class="text tab-2"><strong>借款金额：●7</strong></p>
      <p class="text tab-2"><strong>借款期数：●8期，自贷款发放之日起算</strong></p>
      <p class="text tab-2"><strong>贷款利息及相关费用：</strong></p>
      <p class="text tab-2">
        <strong>（1）本合同项下贷款年化综合资金成本率为36%，包括贷款利率和相关费用，其中贷款利率●10%，即贷款市场报价利率●11%(LPR发布时间：●12；期限品种：■1年期□5年期以上)的基础上●13（选填“加”或“减”）●14个基点；在借款期限内，该利率保持不变。利息从本合同项下贷款划离甲方账户之日起计息，按本合同约定的贷款利率、贷款金额和贷款期限等额本息计算利息，至贷款全部结清日止。按贷款利率、贷款金额和实际借款期限按月计息，若不足一个月则按日计息。日利率=年利率/360，月利率=年利率/12。在贷款存续期间内贷款利率不调整。</strong>
      </p>
      <p class="text tab-2"><strong>（2）本合同项下相关费用及支付方式以乙方与担保机构另行签署的《服务合同》约定为准。</strong></p>
      <p class="text tab-2"><strong>还款方式：等额本息</strong></p>
      <p class="text tab-2"><strong>还款日：为贷款期限起始日的对应日。当月没有对应日的，则当月的最后一天为还款日；还款日为法定节假日的，不顺延。</strong></p>
      <p class="text tab-2"><strong>收款方户名：●14</strong></p>
      <p class="text tab-2"><strong>收款方账号：●15</strong></p>
      <p class="text tab-2"><strong>收款方开户银行：●16</strong></p>
      <p class="text tab-2"><strong>特别约定：因贷款人实际放款日期与乙方账户资金到账日期可能不一致的，乙方予以理解并且保证不提出任何异议。</strong></p>
      <p class="text tab-2">乙方同意在贷款人发放贷款时，可以直接发放至乙方约定账户或贷款人通过第三方支付将贷款发放至乙方约定账户中。</p>
      <p class="text tab-2"><strong>第二条 定义与解释</strong></p>
      <p class="text tab-2">除另有约定外，本合同中所涉及的部分名词解释如下：</p>
      <p class="text tab-2">
        1贷款人：指青海银行股份有限公司（以下简称“贵行”）有权依照本合同相关约定单独对您授信并指定所属分支机构向您发放贷款，贷款人将仅为青海银行或青海银行指定所属分支机构,放款分支机构以本合同签章为准。</p>
      <p class="text tab-2">2业务平台：您向贷款人提出贷款申请、查看贷款额度等操作的贷款人或其合作方的网站或其他与本贷款相关的软件服务端。</p>
      <p class="text tab-2">3还款日：指贷款人向您发放贷款后您应按期归还贷款本息及其他应付款项的日期。</p>
      <p class="text tab-2">4受托支付：指贷款人根据您的支付委托，将贷款资金支付给符合合同约定用途的您的交易对象的支付方式。</p>
      <p class="text tab-2">5自主支付：指贷款人根据您的申请将贷款资金直接发放至您的账户，并由您自主支付给符合合同约定用途的您的交易对象的支付方式。</p>
      <p class="text tab-2">6逾期：指您未按约定的还款日向贷款人足额偿还已到期贷款本息及其他应付款项。</p>
      <p class="text tab-2">
        7实现债权的费用：包括但不限于诉讼/仲裁费用、律师代理费用、调查取证费用、公证费用、送达费用、公告费用、财产保全费用、执行费用、评估费用、鉴定费用、拍卖费用、催收费用、差旅费用等其他为实现债权而支出的合理费用。</p>
      <p class="text tab-2">8法律法规：包括中华人民共和国的法律、行政法规、最高人民法院的司法解释以及金融监管机构的规章、规定与命令、通知等。</p>
      <p class="text tab-2">9本合同：包括贷款人与您签署的本《个人借款合同》及其附件（如有）,亦包括后续对该合同及附件的任何有效修订和补充。</p>
      <p class="text tab-2">10年、月、日：除非在本合同文义中有明确的其他含义，“年”“月”“日”均指按照公历计算的自然年、自然月、自然日。</p>
      <p class="text tab-2">11本合同中贷款、借款为同一含义。</p>
      <p class="title"><strong>第三条 甲方及被授权委托人基本信息</strong></p>
      <p class="text tab-2"><strong>甲方：青海银行股份有限公司</strong></p>
      <p class="text tab-2"><strong>法定代表人：李锦军</strong></p>
      <p class="text tab-2"><strong>地址：青海省西宁市城西区西关大街130号1号楼</strong></p>
      <p class="text tab-2"><strong>联系方式：0971-96399</strong></p>
      <p class="text tab-2"><strong>被授权委托人：青海银行股份有限公司城北支行</strong></p>
      <p class="text tab-2"></p>
      <p class="title tab-2"><strong>第四条 乙方承诺</strong></p>
      <p class="text tab-2"><strong>乙方在签约前须确认并保证乙方同时满足以下条件，并承诺在本合同有效期内始终有效：</strong></p>
      <p class="text tab-2">1.乙方借款人承诺其为具有完全民事行为能力的中华人民共和国公民，对其全部资产拥有充分的权利，、具有完全的、有效的签订和履行本合同的资格和能力，能够独立承担民事责任；</p>
      <p class="text tab-2">2.乙方借款人承诺签订和履行本合同不违反乙方借款人作为签约一方的任何合同以及相关法律法规的规定，与乙方借款人应承担的其他合同项下的义务均无抵触；</p>
      <p class="text tab-2">3.乙方承诺使用以乙方名义开户并设置了密码的用以签约的账户在业务平台所从事的借款人承诺使用以借款人本人名义开户并设置了密码的借款人用以签约的账户在借款平台所从事的所有行为均视为乙方借款人本人行为，包括但不限于订立本合同、申请支用贷款和归还贷款等，该等行为的法律后果均由乙方本人承担借款人本人承担；</p>
      <p class="text tab-2">4.乙方借款人承诺其具备真实、完整的还款意愿和还款能力，信用状况良好，无不良信用记录；</p>
      <p class="text tab-2">5.乙方承诺其提供给甲方的借款人承诺其提供给贷款人的所有文件和资料都是真实、准确、完整和有效的，不存在任何虚假记载、重大遗漏或误导性陈述；</p>
      <p class="text tab-2">6.乙方确认，甲方已提请乙方特别借款人确认，贷款人已提请借款人特别注意本合同中有关乙方借款人权利义务的全部条款，并应乙方的要求对该等条款做了相应借款人的要求对该等条款做了相应的说明；</p>
      <p class="text tab-2">7.乙方借款人承诺严格按照合同约定的支付方式使用贷款，积极配合并自觉全面接受甲方贷款人对本合同项下贷款支付的检查、监督和管理，并按照甲方贷款人要求及时完整提供贷款资金使用记录和资料；</p>
      <p class="text tab-2">8.乙方承诺当发生影响偿债能力的不利事项时及时书面通知甲方。</p>
      <p class="text tab-2"><strong>第五条  合同形式</strong></p>
      <p class="text tab-2">乙方与甲方一致同意本合同以数据电文形式签订并认同其效力，甲方授权委托青海银行股份有限公司下属分支机构为贷款资金发放主体。</p>
      <p class="text tab-2"><strong>第六条 合同的生效</strong></p>
      <p class="text tab-2">
        <strong>乙方在业务平台点击“同意并提交”即表示乙方已阅读并无条件接受本合同项下全部条款。乙方在贷款平台确认本合同后并不导致本合同立即生效，仅在经过甲方审核通过并将贷款资金划入乙方收款账户时，本合同开始在乙方和甲方之间生效。</strong>
      </p>
      <p class="text tab-2"></p>
      <p class="text tab-2"><strong>第七条 借款发放与支付</strong></p>
      <p class="text tab-2">一、借款发放</p>
      <p class="text tab-2"><strong>乙方在贷款平台确认本合同后</strong>，即表示乙方不可撤销的同意甲方向其发放借款。</p>
      <p class="text tab-2">乙方了解并同意甲方有权根据法律法规、规章的规定，针对乙方资</p>
      <p class="text tab-2">信的变化以及有关法律法规、市场的变化等因素对本合同项下借款发放的前提条件进行调整、修改和补充。</p>
      <p class="text tab-2">二、借款支付</p>
      <p class="text tab-2">（一）乙方应采用自主支付方式使用本合同项下借款。</p>
      <p class="text tab-2">本合同所指自主支付是指甲方根据乙方的提款申请将借款资金发放至乙方绑定账户，并由乙方自主支付给符合合同约定用途的交易对象。</p>
      <p class="text tab-2">
        （二）采用自主支付方式的，乙方不可撤销地授权甲方将借款划至乙方在业务平台绑定的收款账户，甲方有权对该账户进行监控，乙方负有接受并配合甲方对该账户进行监控的义务。乙方应定期报告或告知甲方借款资金支付情况，甲方有权通过账户分析、凭证查验或现场调查等方式核查借款支付是否符合约定用途。
      </p>
      <p class="text tab-2">（三）乙方不可撤销地授权甲方采用自主支付方式将本合同项下借款直接划至乙方在业务平台绑定的收款账户，即为甲方依约履行了向乙方发放借款的义务。</p>
      <p class="text tab-2">
        （四）<strong>乙方应保证提供准确的账户信息给贷款人，若乙方提供的账户信息有误、账户状态不正常、或者因提供账户的开户银行汇款转账系统延误、故障或者因人行跨行转账系统延误、故障等原因导致贷款人发放的贷款未能支付至乙方指定账户的，贷款人不承担责任，贷款利息仍然按约定的贷款发放日起算。若因上述原因导致贷款人放款失败的，乙方需重新申请放款。若因乙方提供的账户信息错误，给贷款人造成损失的，乙方应承担赔偿责任。</strong>
      </p>
      <p class="text tab-2">（五）贷款发放后，贷款人可根据乙方的注册账户（手机号码）向乙方发出放款通知等文件或信息。</p>
      <p class="text tab-2"><strong>第八条 借款金额</strong></p>
      <p class="text tab-2">1.借款金额具体参见本合同第一条，贷款发放后，乙方可登录业务平台或收款账户查询。</p>
      <p class="text tab-2">2.若贷款人实际发放的金额大于约定贷款金额的，您同意最终的贷款金额以本合同第一条约定的贷款金额为准。</p>
      <p class="text tab-2">
        3.贷款人有权要求您返还实际发放金额与本合同第一条约定的贷款金额之差额的资金，您在接到贷款人书面通知后3个工作日内应将前述差额资金返还给贷款人，贷款人对在上述3个工作日内返还的该等差额资金不计利息，<strong>超过上述时限后您应就该等差额资金按本合同约定的贷款利率向贷款人计付利息，您同意贷款人可根据本合同还款的约定发起代扣还款操作。</strong>
      </p>
      <p class="text tab-2"><strong>第九条 借款期限</strong></p>
      <p class="text tab-2"><strong>借款期限以本合同第一条约定为准。实际借款发放日以借款资金从甲方账户划出至收款账户的日期为准。</strong></p>
      <p class="text tab-2"></p>
      <p class="text tab-2"><strong>第十条 借款用途</strong></p>
      <p class="text tab-2">乙方承诺按照本合同第一条约定的借款用途使用本合同项下借款，本贷款用途仅限于本人个人消费，乙方承诺合规合法使用贷款资金，否则引起的一切后果由乙方自行承担。该等承诺包括但不限于：</p>
      <p class="text tab-2">1.贷款资金不会以任何形式进入证券市场，或用于股本权益性投资；</p>
      <p class="text tab-2">2.贷款资金不得用于经营活动；</p>
      <p class="text tab-2">3.贷款资金不得用于购房、投资房地产、进行房地产项目开发；</p>
      <p class="text tab-2">4.贷款资金不得用于法律法规禁止或限制的其他用途。</p>
      <p class="text tab-2"><strong>第十一条 借款利率结算标准</strong></p>
      <div>
        <p class="text tab-2">一、借款利率</p>
      </div>
      <p class="text tab-2">本合同项下的借款利率按照本合同第一条约定执行。</p>
      <p class="text tab-2">二、结算标准</p>
      <p class="text tab-2">1.借款成本自借款发放日起（含发放日）按日计算；</p>
      <div>
        <p class="text tab-2">2.甲方及其合作方有权自行或委托第三方支付机构于每期还款日及借款到期日从乙方还款账户中扣除当期应收本金、利息、罚息（或有）等全部应还款项。</p>
      </div>
      <p class="text tab-2"></p>
      <div>
        <p class="text tab-2"><strong>第十二条 还款</strong></p>
      </div>
      <div>
        <p class="text tab-2">一、还款方式</p>
      </div>
      <p class="text tab-2">
        （一）<strong>乙方按等额本息还款法分●18次偿还本合同项下贷款本息，委托深圳市飞贷小额贷款有限公司（以下简称“飞贷小贷”）和中资联担保向贷款人交付，同时乙方同意贷款人可在每个还款日自行向乙方收取或授权飞贷小贷和中资联担保向乙方代为收取每期应还贷款本息和相应费用（如有）。还款方式具体参见本合同第一条。</strong>
      </p>
      <p class="text tab-2">
        <strong>（二）乙方应根据业务平台生成的还款计划表（或期供表）所确定的还款日按时偿还借款本息等（全部应还款项）。还款计划表为本合同的有效组成部分，与本合同具有同等法律效力。乙方可在业务平台查询还款计划表，查询还款日。</strong>
      </p>
      <p class="text tab-2">
        <strong>（三）甲方将根据乙方的贷款本金、贷款利率、贷款期限、还款日期和还款方式等为乙方计算每个还款日的应还款额（包括应还本金、应还利息、应还罚息（或有））。乙方可在业务平台查询每个还款日的应还款额。</strong>
      </p>
      <p class="text tab-2">
        <strong>（四）为偿还合同项下应还款项，乙方无条件不可撤销地同意并授权甲方（及甲方指定合作方）：根据相关合同约定（或乙方申请）向绑定账户开户行、有权的第三方支付机构组织发送代扣指令，从乙方在业务平台绑定的所有账户中划扣相应的应还款项，用于偿还乙方在本合同项下的全部债务，直至清偿完毕；乙方在甲方处有多笔债务的，甲方有权将同一还款日的多笔贷款应还款额合为一笔或分成特定金额，分笔、分批发出交易委托指令。乙方承诺前述交易委托指令视同乙方本人做出。</strong>
      </p>
      <div>
        <p class="text tab-2">二、到期还款</p>
      </div>
      <p class="text tab-2">
        （一）乙方应保证乙方的还款账户付款功能未受限制，并在每期还款日之前，将全部应还款项足额存入乙方的还款账户，按照本协议约定的还款方式完成还款且乙方同意甲方授权贷款人或飞贷小贷委托的第三方支付机构在每个还款日从乙方的还款账户扣收应还贷款本息和相应费用（如有）。乙方指定的还款账户以本合同第一条约定为准。
      </p>
      <p class="text tab-2">（二）乙方的还款时间以甲方从乙方的还款账户实际划扣到还款资金的时间为准，还款金额以甲方实际收到乙方的还款金额为准。</p>
      <p class="text tab-2">
        （三）还款顺序：首先用于偿还本合同约定的应由乙方承担而垫付的各项费用以及实现债权的费用（以下统称为“费用”），包括但不限于诉讼费、律师代理费、催收费用等，剩余款项按照先利息后本金的原则偿还；且甲方有权对乙方还款的清偿顺序做出合理调整。
      </p>
      <div>
        <p class="text tab-2">三、逾期还款</p>
      </div>
      <p class="text tab-2">
        <strong>乙方了解并接受：若乙方未按前款约定履行义务，则甲方及其合作方</strong>或其委托的第三方支付机构<strong>有权直接从乙方在业务平台上提供或绑定的银行账户中扣收应收款项（贷款本金、利息、罚息）逾期之后计收罚息，罚息利率按照借款利率上浮50%计算，甲方及其合作方</strong>或其委托的第三方支付机构<strong>有权通过拆分成多笔分批次从上述银行账户中扣款。乙方自行承担因扣款而产生的利息、手续费、汇兑等损失。</strong>
      </p>
      <div>
        <p class="text tab-2">四、提前还款</p>
      </div>
      <p class="text tab-2">
        乙方须提前通过业务平台提出申请。乙方应按照相关合同约定提前结清全部应还款项。乙方提前还本应按照还本数额、实际借款天数及本合同约定的借款利率计算利息，并同时结清相应应还款项（本金、利息、罚息（或有））。</p>
      <p class="text tab-2">五、代为偿还</p>
      <p class="text tab-2">
        本合同项下，当乙方未按时还款，乙方不可撤销地同意贷款人有权按照其与担保机构签署的《服务合同》中的相关约定，由担保机构为乙方代偿应还未还款项。担保机构为乙方实施代偿后，可自行或委托第三方就其支付的代偿款项向乙方进行追偿。
      </p>
      <p class="text tab-2"><strong>第十三条 提前收贷与合同解除</strong></p>
      <p class="text tab-2">
        发生下列情形之一的，甲方有权提前收回本合同项下已形成的借款债权或/及解除本合同，并有权<strong>直接</strong>或委托第三方支付机构<strong>从乙方在业务平台上提供或绑定的银行账户中</strong>扣收款项以偿还借款本息、罚息（或有）。
      </p>
      <p class="text tab-2">1.乙方未按本合同约定按期足额偿还借款本息；</p>
      <p class="text tab-2">2.乙方丧失民事行为能力而无监护人，或其监护人拒绝履行偿还借款本息义务；</p>
      <p class="text tab-2">3.乙方死亡或被宣告死亡而无继承人或受遗赠人，或其继承人或受遗赠人放弃继承或遗赠，或其继承人或受遗赠人虽接受继承或遗赠，但拒绝履行偿还借款本息义务；</p>
      <p class="text tab-2">4.乙方失踪或被宣告失踪而无财产代管人，或其财产代管人拒绝履行偿还借款本息义务；</p>
      <p class="text tab-2">5.乙方发生或涉及诉讼或仲裁案件；</p>
      <p class="text tab-2">6.乙方提供虚假材料或隐瞒重要事实；</p>
      <p class="text tab-2">7.乙方未经甲方同意擅自改变借款用途，挪用借款或用借款从事非法、违规交易；</p>
      <p class="text tab-2">8.乙方未按照合同约定用途使用、支付借款，或经甲方要求无法提供相应消费凭证的；</p>
      <p class="text tab-2">9.乙方利用虚假合同套取银行资金或授信，或逃废甲方债权；</p>
      <p class="text tab-2">10.乙方拒绝接受或配合甲方对其借款资金使用情况和有关资信状况监督和检查；</p>
      <p class="text tab-2">11.本合同项下担保人违反法律、法规、规章等规定或担保合同的约定，或担保未生效、无效、被撤销，或担保人或抵（质）押物发生不利于甲方债权的变化，或担保人拒绝履行其担保义务；</p>
      <p class="text tab-2">12.乙方出现不良还贷记录或其他违约行为。</p>
      <p class="text tab-2"><strong>第十四条 权利和义务</strong></p>
           
      <p class="text tab-2">一、乙方的主要权利和义务</p>
      <p class="text tab-2">(一)乙方有权要求甲方按本合同约定发放借款。</p>
      <p class="text tab-2">(二)乙方有权要求甲方对乙方提供的财务资料以及生产经营方面的商业秘密予以保密，但法律法规另有规定或本合同另有约定的除外。</p>
      <p class="text tab-2">(三)乙方保证其在业务平台中提供的任何信息均真实、合法、有效。乙方应在业务平台正确填写本人的银行账户卡号和开户行信息，并确保银行账户未受限制。因银行账户信息有误、账户受限等不可归责于甲方的原因造成支付失败的，由乙方自行承担相关的责任。</p>

      <p class="text tab-2">
        <strong>（四）乙方应妥善保管其在业务平台中留存的，包括但不限于账户、密码、数字证书、绑定的手机号码、手机验证码等与本合同项下贷款有关的一切信息。乙方应确保不向其他任何人泄露前述信息。对于因前述信息泄露所导致的损失，由乙方自行承担。如乙方发现有他人冒用或盗用乙方的前述信息或任何其他未经合法授权之情形时，应立即以有效方式通知甲方。同时，乙方充分理解甲方对乙方的请求采取行动需要合理期限，在此之前，甲方对已执行的指令及（或）所导致的乙方的损失不承担任何责任。</strong>
      </p>
      <p class="text tab-2">（五）乙方保证其本合同项下的消费背景真实、合法、有效，并将消费合同、首付款证明或其他甲方要求的证明材料提交给甲方，提交形式包括但不限于书面递交纸质材料或者通过业务平台上传电子文档等。
      </p>
      <p class="text tab-2">（六）乙方应按本合同的约定归还全部贷款本息、罚息（或有）。</p>
      <p class="text tab-2">（七）乙方应按本合同约定的用途使用贷款，未经甲方书面同意乙方不得将贷款挪作他用。</p>
      <div>
        <div>
          <div>
            <p class="text tab-2">（八）乙方应积极配合并自觉全面接受甲方对本合同项下贷款支付的检查、监督和管理，并应按照甲方要求及时完整提供贷款资金使用记录和资料。</p>
          </div>
        </div>
      </div>
      <div>
        <div>
          <div>
            <p class="text tab-2">（九）乙方不得将贷款用于有价证券、期货买卖及股本权益性投资。</p>
          </div>
        </div>
      </div>
      <p class="text tab-2">（十）乙方不得利用本合同或本合同项下的贷款规避相关法律法规或规章的要求（包括但不限于税务方面政策法规的要求），否则与此相关的任何法律责任应由乙方自行承担。</p>
      <p class="text tab-2">
        （十一）乙方承诺配合甲方进行贷款支付管理、贷后管理及其它一切甲方认为必要的调查，包括但不限于接受甲方对本合同项下贷款使用情况和有关乙方财务活动情况进行的监督和检查，按照甲方的要求及时提供真实、准确、完整的资料，并为甲方的前述管理或者调查提供工作方便。
      </p>
      <div>
        <div>
          <div>
            <p class="text tab-2">（十二）乙方应在下列事项发生或可能发生之日起3日内书面通知甲方：</p>
          </div>
        </div>
      </div>
      <p class="text tab-2">1.乙方借款人个人或其家庭发生变故或收入发生变化，导致其经济状况恶化或可能恶化，影响或可能影响其债务偿还能力；</p>
      <p class="text tab-2">2.乙方借款人卷入或即将卷入诉讼或仲裁程序及其他法律纠纷等；</p>
      <p class="text tab-2">3.乙方借款人变更工作单位、住所、通讯地址、联系电话等事项；</p>
      <p class="text tab-2">4.乙方借款人发生失业、离婚、重大疾病等事项；</p>
      <p class="text tab-2">5.发生其他影响或可能影响乙方偿债能力的事项。</p>
      <p class="text tab-2">乙方如发生上述事项，应妥善落实本合同项下的债务清偿，仍应按本合同约定按期足额偿还借款本息及其他全部应还款项（如有），否则视为乙方违约，甲方有权按本合同约定进行处理。</p>
      <p class="text tab-2">（十四）乙方承诺不以与任何第三方纠纷为理由拒绝履行本合同项下义务。</p>
      <p class="text tab-2">
        （十五）贷款期限内，乙方不得随意变更本合同第一条所列乙方约定账户。若确需变更的，应当及时以书面形式将变更事项通知贷款人和飞贷小贷。因未及时通知贷款人和飞贷小贷而造成的全部损失，均由乙方承担全部赔偿。</p>
      <p class="text tab-2">（十六)根据法律、法规、规章等规定及本合同约定享有和承担的其他权利与义务。</p>
      <div>
        <div>
          <div>
            <div>
              <div>
                <p class="text tab-2">二、甲方的主要权利和义务</p>
                <p class="text tab-2">(一）甲方应按照本合同的约定履行权利义务。</p>
              </div>
            </div>
            <p class="text tab-2">(二)因任何有关方面（包括但不限于中国人民银行个人信用信息基础数据库）向甲方提出了解或者查询乙方财产、资信、个人信用信息等情况，甲方有权向包括但不限于中国人民银行个人信用信息基础数据库在内的有关方面（法律、法规要求范围内）提供乙方有关信息材料。甲方有权不得向上述机构以外的其他机构（未在法律、法规要求范围内的）提供从中国人民银行个人信用信息基础数据库了解、查询的征信数据。无论本合同项下的贷款是否终止，有关资料均不予退还。</p>
          </div>
        </div>
      </div>
      <p class="text tab-2 underline strong">(三)甲方有权将其在本合同项下享有的权利义务委托第三方机构行使（包括但不限于资信调查、逾期款项催收等），并向该机构披露乙方相关信息，乙方对此予以认可且无异议。</p>
      <p class="text tab-2">(四)甲方应按照本合同的约定向乙方发放贷款，但由于乙方的原因导致的延迟除外。</p>
      <p class="text tab-2">(五)甲方有权按本合同的约定收回全部贷款本息。</p>
      <p class="text tab-2">(六)甲方有权对乙方的资金、财产、经济等资信状况及贷款使用情况进行检查和监督，并有权取得有关资料，甲方检查和监督可以采取定期与不定期、现场与非现场相结合的方式进行。</p>
      <p class="text tab-2">(七)如有政策性原因或其他突发事件，贷款人有权通知或委托飞贷小贷通知乙方贷款提前到期，根据本款约定宣布贷款提前到期的，由飞贷小贷提前两个工作日通知乙方归还贷款本息，乙方须及时归还贷款本息及相关费用。乙方不得以贷款人未向乙方宣布贷款提前到期为由主张宣布贷款提前到期行为无效或要求撤销代偿行为。</p>
      <p class="text tab-2">(八）根据法律、法规、规章等规定及本合同约定享有和承担的其他权利与义务。</p>
      <p class="text tab-2"><strong>第十五条 信息收集、使用、共享与保护</strong></p>
      <p class="text tab-2">一、收集乙方的信息</p>
      <p class="text tab-2">(一)乙方了解并同意当乙方访问业务平台或乙方使用甲方的服务时，乙方须向甲方主动提供一些信息，且乙方不可撤销的同意并授权甲方为本合同项下贷款之目的通过以下途径获取乙方的信息，且乙方不可撤销的同意并授权下述个人、企业或其他组织根据甲方的指示提供乙方的信息：</p>
      <p class="text tab-2">1.收集乙方留存在甲方的合作机构处与贷款相关的信息；</p>
      <p class="text tab-2">2.向中国人民银行个人信用信息基础数据库、以及其他依法设立的征信机构、资信评估机构或有关法律、监管机构许可的类似机构（以下统称“征信机构”）查询、核实、打印、留存乙方的信息和信用报告；</p>
      <p class="text tab-2">3.向行政机关、司法机关查询、打印、留存与贷款相关的乙方的信息；</p>
      <p class="text tab-2">4.向合法留存乙方信息的自然人、法人以及其他组织收集与贷款相关的乙方的信息。</p>
      <p class="text tab-2">(二)乙方同意并授权甲方收集的乙方信息包括但不限于：</p>
      <p class="text tab-2">1.乙方的身份信息，包括但不限于姓名、证件类型、证件号码、身份证的复印件、扫描件或照片等、住所地址、电话号码、以及其他身份信息；</p>
      <p class="text tab-2">2.乙方在申请、使用甲方提供的服务时所提供以及形成的任何数据和信息；</p>
      <p class="text tab-2">3.乙方的信用信息，包括但不限于乙方的征信记录和信用报告；</p>
      <p class="text tab-2">4.乙方的财产信息，包括但不限于乙方的个人经营状况、财税信息、房产信息、车辆信息、基金、保险、股票、信托、债券、互联网金融等投资理财信息和负债信息等；乙方同意并确认，乙方在将前述信息提供给甲方之前已清楚知晓可能带来的不利后果，包括但不限于甲方基于前述信息对乙方做出负面评价；</p>
      <p class="text tab-2">5.乙方在行政机关、司法机关留存的任何信息，包括但不限于户籍信息、工商信息、诉讼信息、执行信息和违法犯罪信息等；</p>
      <p class="text tab-2">6.与乙方申请或使用的甲方服务相关的、乙方留存在其他自然人、法人和组织的其他相关信息。</p>
      <p class="text tab-2">二、使用乙方的信息</p>
      <p class="text tab-2">为了更好地为乙方提供服务，也为了甲方自身的信贷风险防控，乙方同意并授权甲方将乙方的信息用于如下用途：</p>
      <p class="text tab-2">1.创建数据分析模型，为乙方提供适合于乙方的信贷产品、网络平台、技术等服务，并维护、改进这些服务；</p>
      <p class="text tab-2">2.比较信息的准确性并与第三方征信机构进行验证；</p>
      <p class="text tab-2">3.合理评估乙方的财务状况，防控风险；</p>
      <p class="text tab-2 underline strong">4.因乙方与甲方的纠纷未能够协商解决而需要通过借助催收及法律途径解决的，甲方会将乙方的信息提供给催收公司、律师事务所、法院、仲裁委员会和其他有权机关；</p>
      <p class="text tab-2">5.预防或阻止非法的活动；</p>
      <p class="text tab-2">6.为向乙方推送更优质的产品或服务而开展相关的广告营销活动；</p>
      <p class="text tab-2">7.用于数据分析并经脱敏及加工处理后以信用评分等合法形式对外输出；</p>
      <p class="text tab-2">8.经法律法规或者乙方许可的其他用途。</p>
      <p class="text tab-2">三、分享乙方的信息</p>
      <p class="text tab-2">甲方对乙方的信息承担保密义务，不会为满足第三方的营销目的而向其出售或出租乙方的任何信息，甲方会在下列任一情况下才将乙方的信息与第三方共享：</p>
      <p class="text tab-2">1.在第三方获得乙方的同意或授权，乙方同意并授权甲方将甲方留存的乙方信息（从中国人民银行个人信用信息基础数据库获取的征信数据除外）分享至该第三方；</p>
      <p class="text tab-2 underline strong">2.为建立信用体系，乙方同意并授权甲方向征信机构发送乙方的信息，将乙方的不良信息发送至征信机构，包括但不限于中国人民银行个人信用信息基础数据库或者其他依法设立的征信机构等；</p>
      <p class="text tab-2">3.根据法律法规的规定及有权机关的要求；</p>
      <p class="text tab-2 underline strong">4.若乙方在本合同下的任何应付款项逾期，乙方不可撤销地授权并同意甲方有权在甲方或其合作方的网站或者甲方认为必要的区域范围内的任意位置公示乙方违反本合同的相关信息，包括但不限于姓名/名称、肖像、证件号码、住址、具体违约状况等信息；乙方同意甲方有权停止向乙方提供任何服务，因此给乙方造成损失的，甲方及前述相关主体均不承担赔偿责任。</p>
      <p class="text tab-2">四、乙方的信息保护</p>
      <p class="text tab-2">甲方将根据法律法规规定对乙方的信息予以保密，但下列情形除外：</p>
      <p class="text tab-2">1.法律、法规、规章及其他规范性文件另有规定；</p>
      <p class="text tab-2">2.本合同或相关法律文件另有约定。</p>
      <p class="text tab-2"><strong>第十六条 违约及其违约处理</strong></p>
      <p class="text tab-2"> 一、乙方发生下列任一情况，即构成违约：</p>
      <p class="text tab-2">1.乙方未按本合同规定按时足额偿还贷款本息、罚息（或有）；</p>
      <p class="text tab-2">2.乙方未按本合同约定用途使用贷款的；</p>
      <p class="text tab-2">3.乙方向甲方提供虚假的信息；</p>
      <p class="text tab-2">4.乙方被宣告失踪、处于限制民事行为能力或丧失民事行为能力状态、被刑事监禁、或发生重大疾病、重大事故等可能危及本合同项下贷款安全的情况；</p>
      <p class="text tab-2">5.乙方卷入或即将卷入的诉讼或仲裁程序及其他法律纠纷，足以影响乙方的偿债能力；</p>
      <p class="text tab-2">6.乙方转移资产，以逃避债务的；</p>
      <p class="text tab-2">7.乙方未能履行对甲方及其各级机构或者其他任何第三方负有的任何到期债务；包括但不限于《服务合同》项下债务。</p>
      <p class="text tab-2">8.乙方在甲方处开立的各项账户发生不利变化；</p>
      <p class="text tab-2">9.乙方的资信情况或还贷能力出现其他不利变化（包括但不限于工作调整，收入降低、失业、重大疾病、拖欠其他债务等）；</p>
      <p class="text tab-2">10.乙方在本合同、《服务合同》等协议中做出的任何声明虚假或者未能履行任何保证或承诺或违反合同约定的其他义务； </p>
      <p class="text tab-2">11.乙方在甲方系统中的行为数据或其他信息发生异常变化；</p>
      <p class="text tab-2">12.乙方在中国人民银行个人信用信息基础数据库或其他经国务院相关部门批准的第三方征信机构中的信用数据发生异常变化；</p>
      <p class="text tab-2">13.乙方在业务平台上注册的账户出现异常现象；</p>
      <p class="text tab-2">14.违反法律、法规、规章规定的其他情形。</p>
      <p class="text tab-2">二、若乙方出现本条第一款所述之任何违约情形，或违背乙方在本合同项下其他任何义务、陈述、保证或承诺的，甲方有权采取下列一项或多项措施，包括但不限于：</p>
      <p class="text tab-2">1.要求乙方限期纠正违约行为。</p>
      <p class="text tab-2">2.停止依据本合同或乙方与甲方之间的其他合同向乙方发放任何贷款。</p>
      <p class="text tab-2">3.自主决定本合同、以及乙方与甲方之间其他合同项下乙方未偿还的债务全部或部分提前到期，并有权要求乙方或担保人提前全部清偿。</p>
      <p class="text tab-2">4.可的担保或处分抵押/质押财产（如有）或要求保证人代偿（如有），实现甲方的债权。</p>
      <p class="text tab-2">5.按本合同约定代表乙方转让或赎回乙方在甲方处购买的部分或全部理财产品，并将转让或赎回的交易所得款项用于偿还乙方在甲方及其相关公司处的欠款。</p>
      <p class="text tab-2">6.从乙方在甲方处开立的所有账户（包括但不限于已冻结的各类保证金）中扣收全部或部分贷款本息和其他应付款项。如果账户中款项的币种与贷款币种不同，甲方有权按扣款当日中国人民银行公布的外汇中间价折算成贷款币种清偿贷款。</p>
      <p class="text tab-2">7.要求乙方承担违约责任，并赔偿甲方因此遭受的任何损失和由于行使合法手段追偿贷款（包括但不限于委托债务催讨公司、律师事务所等其他第三方机构代为追讨，申请相关部门进行调查、向法院提起诉讼等）产生的一切费用（包括但不限于诉讼费、财产保全费、执行费、仲裁费、律师代理费、差旅费、评估费、拍卖费、催收费用、调查费用、公证费用等）。</p>
      <p class="text tab-2">8.甲方根据法律法规规定或本合同约定有权采取的其他措施。</p>
      <p class="text tab-2"><strong>第十七条 信息系统中断或故障</strong></p>
      <p class="text tab-2">若业务平台相关系统因下列状况无法正常运作，使乙方无法使用或无法正常使用各项服务或使甲方无法履行本合同时，甲方不承担损害赔偿责任，该状况包括但不限于：</p>
      <p class="text tab-2">(一)在业务平台或与本合同项下贷款相关的其他平台公告之系统维护期间。</p>
      <p class="text tab-2">(二)电信设备出现故障不能正常进行数据传输的。</p>
      <p class="text tab-2">(三)因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素，造成甲方系统障碍不能正常执行业务的。</p>
      <p class="text tab-2">(四)由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。</p>
      <div>
        <div>
          <div>
            <p class="text tab-2"><strong>第十八条 合同的适用法律及争议解决方式</strong></p>
          </div>
        </div>
      </div>
      <p class="text tab-2">一、本合同的签订地：深圳市南山区</p>
      <p class="text tab-2">二、本合同按中华人民共和国法律订立，适用中华人民共和国法律。</p>
      <p class="text tab-2">三、本合同在履行过程中发生争议，可以通过协商解决；协商不成，经甲、乙双方一致同意，任何一方均可向合同签订地或贷款人所在地人民法院起诉。在诉讼期间，本合同不涉及争议部分的条款仍须履行。</p>
      <p class="text tab-2">
        四、如本合同项下乙方的借款出现担保机构代偿的，乙方与担保机构之间发生的争议，乙方同意由履行代偿责任的担保机构所在地人民法院管辖，如在担保机构代偿后担保机构将债权转让的，乙方与债权受让人之间发生的争议，乙方同意由债权受让人所在地人民法院管辖。
      </p>
      <p class="text tab-2">五、乙方与贷款人发生金融权益争议时，可以通过下列途径解决：</p>
      <p class="text tab-2">（一）与贷款人协商解决；</p>
      <p class="text tab-2">（二）向贷款人所在地的银行业监管部门投诉；</p>
      <p class="text tab-2">（三）请求依法设立的第三方机构调解；</p>
      <p class="text tab-2">（四）向本合同项下贷款人指定分支机构所在地有管辖权的人民法院提起诉讼；</p>
      <p class="text tab-2">六、乙方向贷款人咨询、建议或者投诉的，可以通过口头或者书面形式，采取来电、来函、来访等方式提出。</p>
      <p class="text tab-2">七、乙方应当以实名方式向贷款人提出投诉，通过适当方式表明真实身份，并对其投诉目的的合法性及投诉事项的真实性负责。</p>
      <p class="text tab-2">乙方的投诉应当包含以下内容：</p>
      <p class="text tab-2">（一）投诉人姓名、身份证号码、电话、住址等身份识别信息和联系方式；</p>
      <p class="text tab-2">（二）投诉人所办理贷款业务的申请日期、贷款发放日期、产品名称、贷款金额、贷款利率、贷款期限、还款方式、受损害的事实等；</p>
      <p class="text tab-2">（三）投诉人的具体诉求。</p>
      <p class="text tab-2">乙方的投诉内容不全，影响投诉处理的，贷款人可以要求其补正。乙方拒绝补正的，贷款人不予受理。</p>
      <p class="text tab-2"><strong>第十九条 合同的变更、解除和权利义务的转让</strong></p>
      <p class="text tab-2">一、合同的变更和解除</p>
      <p class="text tab-2">本合同生效后，除非本合同另有约除非法律法规及本合同另有约定，甲、乙任何一方不得擅自变更和解除本合同；确需变更或解除的，应经双方协商一致，并达成书面协议。书面协议达成之前，本合同条款仍然有效。</p>
      <p class="text tab-2">二、合同权利义务的转让</p>
      <p class="text tab-2">1.未经甲方贷款人书面同意，乙方借款人不得将本合同项下的权利和义务转让给任何第三方。</p>
      <p class="text tab-2">2.乙方了解并同意：甲方有权将其在本合同项下的债权全部或部分转让给第三方，且甲方的转让行为无须征得乙方的同意，但甲方将以书面形式（包括但不限于短信、电子邮件、书信、业务平台通知等）向乙方通知该等转让行为。</p>
      <p class="text tab-2">3.其它第三方受让本合同项下债权后可再次转让，新债权人有权委托业务平台或其他第三方就该债权转让行为通知乙方，乙方保证继续按照本合同以及新债权人指令履行乙方在本合同项下的义务。</p>
      <p class="text tab-2"><strong>第二十条 通知及法律文书的送达</strong></p>
      <p class="text tab-2">一、通知</p>
      <p class="text tab-2">本合同履行过程中，甲方发送给乙方的书贷款人发送给借款人的书面通知，按照乙方在业务平台信息系统中填写的通讯地址交邮借款人在借款平台信息系统中填写的通讯地址（如有）交邮后的第三个自然日即视为送达。本条所述书面通知的形式还包括但不限于甲方采用在业务知的形式还包括但不限于贷款人采用在借款平台公告、向乙方借款人发送电子邮件、业务借款平台站内信息、手机短信和传真等电子方式，在采用电子方式进行书面通知的情况下发送当日即视为送达。甲方有权决定以前述任何一种或几种形式书面通知乙方。甲方以多种方式向乙方发送贷款人有权决定以前述任何一种或几种形式书面通知借款人。贷款人以多种方式向借款人发送通知的，通知送达时间以最先送达的为准。</p>
      <p class="text tab-2">二、法律文书的送达</p>
      <p class="text tab-2">1.乙方同意与甲方在线订借款人同意与贷款人在线订立本合同；对于因合同争议引起的任何纠纷，乙方声明司法机关借款人声明司法机关（包括但不限于人民法院）可以手机短信或电子邮件等现代通讯方式或邮寄方式向乙方送达法律文书子邮件等现代通讯方式或邮寄方式向借款人送达法律文书（包括诉讼文书）。</p>
      <p class="text tab-2">2.乙方借款人确认并接受将乙方在申请本合同项下贷款时所借款人在申请本合同项下贷款时所提供的手机号码或电子邮箱作为接收法律文书的手机号码或电子邮箱，司法机关以前述码址发出法律文书即视为送达。</p>
      <p class="text tab-2">3.乙方确认并接受邮寄地址为乙方在申请本合同项下贷款时所提供的住宅地址。</p>
      <p class="text tab-2">4.借款人确认并接受司法机关可采取以上一种或多种送达方式向借款人送达法律文书，司法机关采取多种方式向借款人送达法律文书，送达时间以上述送达方式中最先送达的为准。</p>
      <p class="text tab-2">5.乙方借款人确认并接受上述送达方式适用于各个司法阶段，包括但不限于一审、二审、再审、执行以及督促程序（含支付令送达）。</p>
      <p class="text tab-2">6.若乙方上述送达地址及手借款人上述送达地址及手机号码、电子邮箱等联系方式有变更，乙方应当及时告知甲方和借款人应当及时告知贷款人和/或司法机关。</p>
      <p class="text tab-2">7.乙方已阅读本合同借款人已阅读本确认书所有条款，并保证上述送达地址是准确、有效的；如果提供的送达地址不准确，或未及时告知变更后的地址，受送达人本人或法律规定的有权签收人拒绝签收，导致法律文书未能被受送达人实际接收的，文书退回之日视为送达之日。</p>
      <p class="text tab-2"><strong>第二十一条 其它约定事项</strong></p>
      <p class="text tab-2">1.本合同的任何条款或内容被依法撤销或被认定为无效时，其它条款和内容的效力不受影响，仍为有效。</p>
      <p class="text tab-2">
        2.在贷款人的债权尚未得到全部清偿前，乙方出现逾期等任何违约行为时，贷款人在任何时间所给予的宽容、宽限或延缓行使权利，均不损害、影响或限制贷款人应享的一切权利，亦不能解释为贷款人对任何违约行为的许可，更不能视为贷款人放弃现在或将来对上述违约行为采取行动的权利。
      </p>
      <p class="text tab-2">3.无论乙方的贷款是否被批准或贷款期限是否已终止，乙方同意贷款人可保留乙方的个人相关资料，贷款人可不予退还，同时承诺履行保密义务。</p>
      <p class="text tab-2">
        4.乙方同意贷款人对与乙方沟通的电话、语音、文字、图像、视频等进行记录，并且乙方同意将该等文字、语音文件、图像、视频文件等用于贷款人认为合适且必要的目的，包括但不限于将其在针对乙方或其他人的争议解决（如诉讼、仲裁等）中用作证据。
      </p>
      <p class="text tab-2">5.除非有确实且充分的相反证据，否则业务平台及/或贷款人系统生成的电子记账凭证、流水记录等是本合同项下贷款发放及款项偿还情况的有效证据。</p>
      <p class="text tab-2">
        6.乙方同意并确认，贷款人认可的第三方担保人将为乙方在本合同项下借款提供（抵押、质押或保证）担保。担保人承担了担保责任后，贷款人不另行通知乙方该担保责任履行的情形，担保人有权向乙方主张追偿权并从乙方的账户中直接扣款给担保人，直至乙方偿还全部追偿权债务及其他应付款项。
      </p>
      <p class="text tab-2"><strong>乙方声明：乙方已阅读本合同所有条款。乙方对本合同条款的含义及相应的法律后果已全部知晓并充分理解，并完全接受本合同所有条款内容。</strong></p>
      <p class="text tab-2"><strong>特别提示：</strong></p>
      <p class="text tab-2"><strong>在履行本合同过程中，如乙方对青海银行提供的贷款服务有任何建议或意见，乙方可以通过拨打青海银行客户服务中心电话的方式提出。</strong></p>
      <p class="text tab-2"><strong>青海银行客户服务中心电话：0971-96399</strong></p>
      <p class="text tab-2"><strong>贷款人（甲方）或委托授权人：青海银行股份有限公司城北支行</strong></p>
      <p class="text tab-2"><strong>（盖章） </strong></p>
      <p class="text tab-2"><strong>签署日期：●21 </strong></p>
      <br>
      <p class="text tab-2"><strong>签名）●20</strong></p>
      <p class="text tab-2"><strong>借款人（乙方）：●19</strong></p>
      <p class="text tab-2"><strong>签署日期：●22 </strong></p>
      <p class="text tab-2"></p>
    </section>
  </div>
</template>

<script>
export default {
  name: 'fd-loan'
}
</script>
